module.exports = __webpack_public_path__ + "assets/images/crates.a16ee12f.jpg";